<template>
  <div  class="export-list-section mb-4"
        v-if="items && items.length">
    <!-- Header -->
    <div class="export-list-header px-2 py-2">
      <div class="d-flex align-items-center gap-2 mb-1">
        <component :is="headerIcon" :size="15" :stroke-width="1.5" class="text-white-80" />
        <h6 class="export-list-title mb-0">{{ title }}</h6>
      </div>
      <p class="export-list-subtitle mb-0">{{ subtitle }}</p>
    </div>

    <!-- Scrollbare Liste -->
    <div class="export-list-container px-2">
      <div class="export-list-scroll">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="export-item"
          @click="$emit('item-click', item)"
        >
          <div class="d-flex gap-2 align-items-start">
            <!-- File Icon -->
            <div class="export-icon-wrapper">
              <component :is="itemIcon" :size="13" :stroke-width="1.2" class="text-white-80" />
            </div>

            <!-- Content -->
            <div class="export-content flex-grow-1">
              <div class="export-title text-truncate">{{ item.label }}</div>
              <div class="export-filename text-truncate">{{ item.filename }}</div>

              <!-- Metadata -->
              <div class="export-meta d-flex align-items-center">
                <span class="flex-shrink-0">{{ formatTimestamp(item.timeUTC) }}</span>
                <span class="export-meta-divider flex-shrink-0"></span>
                <span class="flex-shrink-0">{{ item.size }}</span>
                <span class="export-meta-divider flex-shrink-0"></span>
                <span class="flex-shrink-0">{{ item.type }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Download, FileText, CalendarArrowUp } from 'lucide-vue-next';
import dayjs from 'dayjs';

export default {
  name: 'SideNotes',

  components: {
    Download,
    FileText,
    CalendarArrowUp
  },

  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    items: { type: Array, default: () => [] },
    headerIcon: { type: [String, Function], default: 'Download' },
    itemIcon: { type: [String, Function], default: 'FileText' }
  },

  emits: ['item-click'],

  methods: {
    formatTimestamp(timeUTC) {
      if (!timeUTC) return '';
      return dayjs(timeUTC).format('DD.MM.YYYY HH:mm');
    }
  }
}
</script>

<style lang="scss" scoped>
/* Letzte Exporte Styles */
.export-list-section {
  border-radius: 4px;
}

.export-list-header {
  padding-bottom: 6px;
}

.export-list-title {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 18.75px;
  font-weight: normal;
}

.export-list-subtitle {
  font-size: 11px;
  color: #6b7280;
  line-height: 15px;
}

.text-white-80 {
  color: rgba(255, 255, 255, 0.8);
}

.export-list-container {
  padding-bottom: 22.5px;
}

.export-list-scroll {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

.export-item {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 2px;
  padding: 6px 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    cursor: pointer;
  }
}

.export-icon-wrapper {
  padding-top: 1.875px;
  width: 13px;
  height: 15px;
  flex-shrink: 0;
}

.export-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.export-title {
  font-size: 11.3px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 15px;
}

.export-filename {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 16.5px;
  white-space: pre;
}

.export-meta {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 10px;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;

  span {
    white-space: nowrap;
  }
}

.export-meta-divider {
  width: 2px;
  height: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  transform: skewX(-19deg);
  margin: 0 6px;
}
</style>
